import { FC, useState } from "react";
import "./SidebarCouponsFilter.scss";
import SidebarFilter from "../../../SidebarFilter/SidebarFilter";
import moment from "moment";
import { useForm } from "react-hook-form";
import { Col, FormGroup, Row } from "react-bootstrap";
import ReactSelect from "react-select";
import { useStatus } from "../../../../providers/Financial/Coupons/Status/StatusProvider";
import { customStyles } from "../../../../models/SelectCustomStyles";
import { useCoupons } from "../../../../providers/Financial/Coupons/CouponsProvider";

interface SidebarCouponsFilterProps {}

// @ts-ignore
export const defaultValues = {
  identifier: "",
  expiration_date: "",
  plan_coupon_status_id: 0,
} as any;

const SidebarCouponsFilter: FC<SidebarCouponsFilterProps> = () => {
  const [selectedStatus, setSelectedStatus] = useState<any>("");

  const { statusOptions } = useStatus();
  const { setParams } = useCoupons();
  const { handleSubmit, register, setValue } = useForm<any>({ defaultValues });

  const onSubmit = async (data: any) => {
    const {
      page: _page,
      perPage: _perPage,
      withPaginate: _withPaginate,
      ...rest
    } = data;

    const filter = {
      ...rest,
      identifier: data?.identifier ?? null,
      expiration_date: data?.expiration_date
        ? moment(data.expiration_date).format("YYYY-MM-DD")
        : null,
      plan_coupon_status_id: data?.plan_coupon_status_id ?? 0,
    };

    setParams((prev: any) => ({
      ...prev,
      filter: { ...(prev?.filter ?? {}), ...filter },
      page: 1,
      perPage: prev?.perPage ?? 10,
      withPaginate: prev?.withPaginate ?? true,
    }));
  };

  return (
    <SidebarFilter handleSubmit={handleSubmit(onSubmit)}>
      <div className="SidebarCouponsFilter" data-testid="SidebarCouponsFilter">
        <Row className="mt-1">
          <Col>
            <FormGroup className="form-group">
              <label htmlFor="identifier">IDENTIFICADOR</label>
              <input className="form-control" {...register("identifier")} />
            </FormGroup>
          </Col>
        </Row>
        <Row className="mt-1">
          <Col>
            <FormGroup className="form-group">
              <label htmlFor="expiration_date">DATA DE EXPIRAÇÃO</label>
              <input
                type="date"
                className="form-control"
                {...register("expiration_date")}
              />
            </FormGroup>
          </Col>
        </Row>
        <Row className="mt-1">
          <Col>
            <FormGroup className="form-group">
              <label htmlFor="plan_coupon_status_id">Status</label>
              <ReactSelect
                isSearchable
                options={statusOptions}
                value={selectedStatus ?? ""}
                defaultValue={selectedStatus}
                placeholder="Selecione..."
                className={`form-control p-0`}
                noOptionsMessage={() => "Não há registros"}
                styles={customStyles}
                onChange={(val: any) => {
                  setValue("plan_coupon_status_id", val?.value);
                  setSelectedStatus(val);
                }}
              />
            </FormGroup>
          </Col>
        </Row>
      </div>
    </SidebarFilter>
  );
};

export default SidebarCouponsFilter;
